import { createRouter, createWebHistory } from 'vue-router'
import { ref }          from 'vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import StartView from '@/views/new/StartView.vue';
import ProductsView from '@/views/new/ProductsView.vue';
import ProductDetailsView from '@/views/new/ProductDetailsView.vue';
import SummaryView from '@/views/new/SummaryView.vue';
import PaymentView from '@/views/new/PaymentView.vue';
import PaymentCompleteView from '@/views/new/PaymentCompleteView.vue';
import EndView from '@/views/new/EndView.vue';
import UnavailableView from '@/views/new/UnavailableView.vue';
import ThemeView from '@/views/new/ThemeView.vue';
import HeaderView from '@/views/new/HeaderView.vue';
import PaymentFailedView from '@/views/new/PaymentFailedView.vue';
import CancelOrderView from '@/views/new/CancelOrderView.vue';

export const navigationDirection = ref('forward');

const routes = [
    {
        path: '/:kioskId',
        component: DefaultLayout,
        children: [
            {
                path: '',
                name: 'Start',
                component: StartView,
            },
            {
                path: 'products',
                name: 'Products',
                component: ProductsView,
            },
            {
                path: 'product',
                name: 'ProductFallback',
                component: ProductDetailsView,
            },
            {
                path: 'product/:productId',
                name: 'ProductDetails',
                component: ProductDetailsView,
            },
            {
                path: 'summary',
                name: 'Summary',
                component: SummaryView,
            },
            {
                path: 'cancel-order',
                name: 'CancelOrder',
                component: CancelOrderView,
            },
            {
                path: 'payment',
                name: 'Payment',
                component: PaymentView,
            },
            {
                path: 'payment-complete',
                name: 'PaymentComplete',
                component: PaymentCompleteView,
            },
            {
                path: 'payment-failed',
                name: 'PaymentFailed',
                component: PaymentFailedView,
            },
            {
                path: 'end',
                name: 'End',
                component: EndView,
            },
            {
                path: 'unavailable',
                name: 'Unavailable',
                component: UnavailableView,
            },
            {
                path: 'theme',
                name: 'Theme',
                component: ThemeView,
            },
            {
                path: 'header',
                name: 'Header',
                component: HeaderView,
            },
        ],
    }


    // { // 02-grid
    //     path: '/',
    //     name: 'products-grid',
    //     component: ProductsGrid,
    // },
    // { // 02-list
    //     path: '/products-list',
    //     name: 'products-list',
    //     component: ProductsList,
    // },
    // { // 03
    //     path: '/product/:productId',
    //     name: 'product-view',
    //     component: ProductView,
    //     props: true
    // },
    // { // 04
    //     path: '/summary',
    //     name: 'summary-view',
    //     component: SummaryView,
    // },
    // { // 5
    //     path: '/payment-process',
    //     name: 'payment-process',
    //     component: PaymentProcess
    // },
    // { // 6
    //     path: '/payment-complete',
    //     name: 'payment-complete',
    //     component: PaymentComplete
    // },
    // { // allergens
    //     path: '/allergens',
    //     name: 'allergens-view',
    //     component: AllergensView
    // },
    // { // hlaska - storno
    //     path: '/message-cancel',
    //     name: 'message-cancel',
    //     component: MessageCancel
    // },
    // { // hlaska - platba
    //     path: '/message-payment',
    //     name: 'message-payment',
    //     component: MessagePayment
    // },
    // { // mimo provoz
    //     path: '/out-of-service',
    //     name: 'out-of-service',
    //     component: OutOfService
    // },
    // { // Template overview
    //     path: '/theme/:themeId',
    //     name: 'template-overview',
    //     component: TemplateView
    // }
]

const router = createRouter({
    history: createWebHistory('/kiosk'),
    routes
});

router.beforeEach((to, from, next) => {
    // Determine direction based on route meta or navigation action
    // You can customize this logic based on your specific routes
    if (to.path === '/' && from.path.includes('/product')) {
        navigationDirection.value = 'backward'
    } else {
        navigationDirection.value = 'forward'
    }
    next();
});

export default router;
